module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/bg3.d2f07882.jpg";